import Decimal from 'decimal.js'
import { round } from 'lodash-es'
import calculateTax from 'views/Sale/utils/orderCalculation/taxCalculation'

function calculateProfitMargin(
    price: number,
    cost: number = 0,
    taxRate?: number,
    isTaxInclusive?: boolean,
): number | undefined {
    if (price === 0) return undefined

    var taxAmount =
        isTaxInclusive && (taxRate ?? 0) > 0
            ? calculateTax(new Decimal(price), taxRate, isTaxInclusive)
            : // Tax-Exclusive : assume Price = Pure Price
              new Decimal(0)

    // Gross Price : Price without Tax
    var grossPrice = price - taxAmount.toNumber()

    // Round to the nearest int
    // Formula : ( <Raw Profit per each> / Gross Price ) * 100
    // Raw Profit per each : Gross Price - cost
    return round(((grossPrice - cost) / grossPrice) * 100)
}

export default calculateProfitMargin
